import FiltersIcon from '@/assets/filters-icon';
import { TradingPanel, TradingText } from '@trading-ui/core';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import * as styles from './NoFiltersPanel.css';

export default function NoFiltersPanel() {
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      style={{ width: '100%', height: '100%' }}>
      <TradingPanel className={styles.root}>
        <FiltersIcon size={80} color="#047dba" />
        <div className={styles.textContainer}>
          <TradingText
            text={t('consumer.noFiltersPanel.noFiltersMessage')}
            variant="h6"
            style={{ marginBottom: '0.5rem' }}
          />
          <TradingText
            text={t('consumer.noFiltersPanel.instructionMessage')}
            variant="body2"
            style={{ opacity: 0.7 }}
          />
        </div>
      </TradingPanel>
    </motion.div>
  );
}
